<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="true"
      [title]="proName + ('\'s Properties' | translate)" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    @if (loaded) {
      <tidy-row>
        <form [formGroup]="searchForm" novalidate action="#">
          <tidy-search-input
            formControlName="search"
            [placeholder]="'Search properties or service types'"
            [icon]="'assets/svg/search.svg'" />
        </form>
      </tidy-row>
      @if (filteredServiceCategories.length === 0) {
        <tidy-alert class="grey-background">
          <tidy-text [body]="'No results'" />
        </tidy-alert>
      }
      @for (category of filteredServiceCategories; track category) {
        <tidy-row [alignLastItemRight]="true" class="extra-top-padding">
          <tidy-image
            [src]="filteredPropertiesByService[category].icon"
            class="header-size" />
          <tidy-text
            [header]="category"
            [translate]="false" />
          <tidy-text
            [actionBody]="'Add'"
            class="link"
            (action)="toggleAddPropertiesForService(getServiceCategoryById(category))" />
        </tidy-row>
        @if (filteredPropertiesByService[category]?.showAddProperties && activeServiceCategory) {
          @if (missingProperties?.length > 0) {
            <tidy-card>
              <form [formGroup]="addPropertiesForm" novalidate>
                @if (missingProperties?.length > 0) {
                  <tidy-row class="extra-bottom-padding">
                    <tidy-radio-button
                      [label]="('What properties do you want to add ' | translate) + proName + (' to?' | translate)"
                      formControlName="addType"
                      [form]="addPropertiesForm.controls.addType"
                      [items]="[{value: 'all', viewValue: 'All Properties'}, {value: 'select', viewValue: 'Select Properties'}]"
                      (optionChange)="updateAddType($event)" />
                  </tidy-row>
                  @if (addPropertiesForm.get('addType')?.value === 'select') {
                    <tidy-row>
                      <tidy-select
                        [icon]="'assets/svg/home.svg'"
                        [label]="'Select properties'"
                        [items]="missingProperties"
                        [form]="addPropertiesForm.controls.selectedProperties"
                        formControlName="selectedProperties"
                        [multiple]="true"
                        (optionChange)="onPropertySelectionChange()" />
                    </tidy-row>
                  }
                  <tidy-row class="align-right">
                    <tidy-button
                      [text]="'Cancel'"
                      class="secondary"
                      [action]="boundCancelAddProperties" />
                    <tidy-button
                      [action]="boundAddToProperties"
                      [text]="selectedMissingProperties.length > 0 ? ('Add to ' | translate) + selectedMissingProperties.length + (' Properties' | translate) : 'Select Properties'"
                      class="primary"
                      [disabled]="selectedMissingProperties.length === 0 || isAddingProperties" />
                  </tidy-row>
                }
              </form>
            </tidy-card>
          }
        }
        @for (property of filteredPropertiesByService[category].properties; track property) {
          <tidy-card>
            <tidy-card-button (action)="goToProperty(property)">
              <tidy-row class="vertical-align-center">
                <tidy-text
                  [body]="property.name"
                  [translate]="false"
                  style="margin-right: 5px;" />
                <tidy-text
                  [smallHelper]="'Remove'"
                  class="link"
                  (action)="removeProFromCategory(property)" />
              </tidy-row>
            </tidy-card-button>
          </tidy-card>
        }
        @if (filteredPropertiesByService[category].properties?.length === 0) {
          <tidy-alert class="grey-background">
            <tidy-text
              [body]="'No properties assigned to this pro'" />
          </tidy-alert>
        }
      }
    }

    @if (!loaded) {
      <tidy-card style="padding: 0px; height: 100px;">
        <ion-skeleton-text animated style="width: 100%; height: 100px; border-radius: 6px; margin: 0;" />
      </tidy-card>
    }

  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}